import React, { useState } from 'react';
import { makeStyles, TextField, Typography, Select, MenuItem, FormGroup, FormControlLabel, Checkbox, FormHelperText } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Badge from '../../assets/images/badge.svg';
import CCRCommonHeader from '../common/CCRCommonHeader';
import { useStyles } from "./CCRStyles";

const styles = makeStyles((theme) => ({
    validError: {
        "margin-top": "0px",
        "text-align": "left",
        color: "#f44336",
        "font-size": "12px"
    }
}));

const BlueCheckbox = withStyles({
    root: {
        '&$checked': {
            color: '#4785FF',
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

const CCRSignUpForm = (props) => {
    const { validError } = styles();
    const ccrStyles = useStyles();

    const [cssFormLoading, setCssFormLoading] = useState(false);
    const [emailError, setEmailError] = useState("");
    const [firstNameError, setFirstNameError] = useState("");
    const [lastNameError, setLastNameError] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [confirmPasswordError, setConfirmPasswordError] = useState("");
    const [termsError, setTermsError] = useState("");
    const [termsChecked, setTermsChecked] = useState(false);

    function cancel() {
        localStorage.clear();
        window.location.href = `${props.appConfig.postLogOutUri || window.location.origin}${getUrlWithoutSlash(props.appConfig.postLogOutUri)}`;
    }

    const getUrlWithoutSlash = (url) => {
        if (!url) return '/';
        if (url[(url.length) - 1] === '/') return '';
        return '/'
    }

    function verification(username, password, confirmPassword, given_name, family_name) {
        var regix = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,64})");
        let isVerified = true;

        if (username === undefined || username.trim() === "") {
            setEmailError("Please enter your email");
            isVerified = false;
        } else {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!re.test(username)) {
                setEmailError("Please enter a valid email address");
            }
        }

        //for password validation
        if (password == null || password === "") {
            setPasswordError("Password is required");
            isVerified = false;
        } else if (regix.test(password) === false) {
            setPasswordError(`Password must be between 8 and 64 characters.
                The password must have followings:
                <div>&nbsp; -a lowercase letter</div>
                <div>&nbsp; -a uppercase letter</div>
                <div>&nbsp; -a digit</div>
                &nbsp;-a symbol`);
            isVerified = false;
        } else {
            setPasswordError("");
        }

        if (confirmPassword == null || confirmPassword === "") {
            setConfirmPasswordError("Confirm Password is required");
            isVerified = false;
        } else if (password !== "" && confirmPassword !== "" && password !== confirmPassword) {
            setConfirmPasswordError("Password and Confirm Password must be same");
            isVerified = false;
        } else if (regix.test(confirmPassword) === false) {
            setConfirmPasswordError(`Password must be between 8 and 64 characters.
                The password must have followings:
                <div>&nbsp; -a lowercase letter</div>
                <div>&nbsp; -a uppercase letter</div>
                <div>&nbsp; -a digit</div>
                &nbsp; -a symbol`);
            isVerified = false;
        } else {
            setConfirmPasswordError("");
        }


        if (family_name == null || family_name === "") {
            setLastNameError("Last Name is required");
            isVerified = false;
        } else {
            setLastNameError("");
        }

        if (given_name == null || given_name === "") {
            setFirstNameError("First Name is required");
            isVerified = false;
        } else {
            setFirstNameError("");
        }

        if (!termsChecked) {
            setTermsError("Please agree to the terms.")
        } else {
            setTermsError("");
        }

        return isVerified;
    }

    function emailchange(e) {
        if (e.target.value == null || e.target.value === "") {
            setEmailError("Email is required");
        }
        else {
            setEmailError("");
        }
        props.onChange(e);
    }

    function firstNamechange(e) {
        if (e.target.value == null || e.target.value === "") {
            setFirstNameError("First name is required");
        }
        else {
            setFirstNameError("");
        }
        props.onChange(e);
    }

    function lastNamechange(e) {
        if (e.target.value == null || e.target.value === "") {
            setLastNameError("Last name is required");
        }
        else {
            setLastNameError("");
        }
        props.onChange(e);
    }

    function onRegionChange(e) {
        props.onChange(e);
    }

    const handleChangeTerms = (event) => {
        setTermsChecked(event.target.checked);
        setTermsError(false);
    };

    function passwordchange(e) {
        var regix = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,64})");
        if (e.target.value == null || e.target.value === "") {
            setPasswordError("Password is required");
        }
        else if (regix.test(e.target.value) === false) {
            setPasswordError(`Password must be between 8 and 64 characters.
            The password must have followings:
            <div>&nbsp;-a lowercase letter</div>
            <div>&nbsp;-a uppercase letter</div>
            <div>&nbsp;-a digit</div>
            &nbsp;-a symbol`);
        }
        else {
            setPasswordError("");
        }
        props.onChange(e);
    }

    function confirmPasswordchange(e) {
        var regix = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,64})");
        if (e.target.value == null || e.target.value === "") {
            setConfirmPasswordError("Confirm Password is required");
        }
        else if (regix.test(e.target.value) === false) {
            setConfirmPasswordError(`Password must be between 8 and 64 characters.
            The password must have followings:
            <div>&nbsp; -a lowercase letter</div>
            <div>&nbsp; -a uppercase letter</div>
            <div>&nbsp; -a digit</div>
            &nbsp; -a symbol`);
        }
        else {
            setConfirmPasswordError("");
        }
        props.onChange(e);
    }

    function signUp() {
        setCssFormLoading(true);
        // const { username, password, confirmPassword, given_name, family_name, 'custom:country': country, 'custom:state': state, 'custom:city': city } = props.formState;
        const { username, password, confirmPassword, given_name, family_name } = props.formState;
        const verified = verification(username, password, confirmPassword, given_name, family_name);
        setCssFormLoading(false);
        if (verified && termsChecked) {
            //call register once it is successful it will call signup()
            props.register();
        }
    }

    return (
        <CCRCommonHeader customTemplate={props.customTemplate} header="Account Creation" headerIcon={Badge} appType={props.appConfig.appType}>
            <div style={{ padding: '10px 0px 40px' }}>

                <div style={{ width: '365px' }}>
                    <Typography variant="caption">Region</Typography>
                    <Select
                        fullWidth
                        name="region"
                        variant="standard"
                        value={props.formState.region}
                        onChange={onRegionChange}
                        style={{ fontSize: '12px' }}
                    >
                        <MenuItem style={{ fontSize: '12px' }} value="Asia">Asia</MenuItem>
                        <MenuItem style={{ fontSize: '12px' }} value="EMEA">EMEA</MenuItem>
                        <MenuItem style={{ fontSize: '12px' }} value="North America">North America</MenuItem>
                    </Select>
                </div>
                <div style={{ width: '365px', marginTop: '10px' }}>
                    <Typography variant="caption">First Name</Typography>
                    <TextField
                        fullWidth
                        name="given_name"
                        variant="standard"
                        placeholder="Enter your First Name"
                        classes={{ root: ccrStyles.customTextField }}
                        error={firstNameError}
                        helperText={firstNameError
                            ? firstNameError
                            : ''
                        }
                        onChange={firstNamechange}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                // props.onEnter(e)
                            }
                        }}

                    />
                </div>
                <div style={{ width: '365px', marginTop: '10px' }}>
                    <Typography variant="caption">Last Name</Typography>
                    <TextField
                        fullWidth
                        name="family_name"
                        variant="standard"
                        placeholder="Enter your Last Name"
                        classes={{ root: ccrStyles.customTextField }}
                        error={lastNameError}
                        helperText={lastNameError
                            ? lastNameError
                            : ''
                        }
                        onChange={lastNamechange}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                // props.onEnter(e)
                            }
                        }}

                    />
                </div>
                <div style={{ width: '365px', marginTop: '10px' }}>
                    <Typography variant='caption'>Email Address</Typography>
                    <TextField
                        fullWidth
                        name="username"
                        variant="standard"
                        placeholder="Enter your Email"
                        classes={{ root: ccrStyles.customTextField }}
                        error={emailError}
                        helperText={emailError
                            ? emailError
                            : ''
                        }
                        onChange={emailchange}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                // props.onEnter(e)
                            }
                        }}

                    />
                </div>
                <div style={{ width: '365px', marginTop: '10px' }}>
                    <Typography variant='caption'>Password</Typography>
                    <TextField
                        fullWidth
                        name="password"
                        variant="standard"
                        placeholder="******"
                        classes={{ root: ccrStyles.customTextField }}
                        type="password"
                        error={passwordError}
                        onChange={passwordchange}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                // props.onEnter(e)
                            }
                        }}

                    />
                    <div className={validError} dangerouslySetInnerHTML={{ __html: passwordError }} />
                </div>
                <div style={{ width: '365px', marginTop: '10px' }}>
                    <Typography variant='caption'>Confirm Password</Typography>
                    <TextField
                        fullWidth
                        name="confirmPassword"
                        variant="standard"
                        placeholder="******"
                        classes={{ root: ccrStyles.customTextField }}
                        type="password"
                        error={confirmPasswordError}
                        onChange={confirmPasswordchange}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                // props.onEnter(e)
                            }
                        }}
                    />
                    <div className={validError} dangerouslySetInnerHTML={{ __html: confirmPasswordError }} />
                </div>
                <div style={{ width: '365px', marginTop: '10px' }}>
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <BlueCheckbox
                                    size='small'
                                    checked={termsChecked}
                                    onChange={handleChangeTerms}
                                />
                            }
                            label={<Typography variant='caption'>I agree to the <a href='https://www.ccr.com/terms-of-use' target='_blank' style={{ color: '#4785FF', cursor: 'pointer' }}>Terms of Use</a> and <a href='https://www.ccr.com/privacy-notice/' target='_blank' style={{ color: '#4785FF', cursor: 'pointer' }} >Privacy Notice</a>.</Typography>}
                        />
                        <FormHelperText style={{ color: '#f44336' }}>{termsError ? termsError : ''}</FormHelperText>
                    </FormGroup>
                </div>
                <div style={{ marginTop: '20px' }}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <div style={{ background: '#FFFFFF', border: '1px solid #4785FF', height: '25px', borderRadius: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer', padding: '0px 60px', fontWeight: 'bold' }} onClick={cancel}>
                            <span style={{ color: '#4785FF' }} >BACK</span>
                        </div>
                        <div style={{ background: '#4785FF', height: '25px', borderRadius: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer', padding: '0px 60px', marginLeft: '5px', fontWeight: 'bold' }} onClick={signUp} disabled={cssFormLoading || props.disableRegisterBtn}>
                            <span style={{ color: 'white' }} >SIGN UP</span>
                        </div>
                    </div>
                    <div style={{ fontSize: '12px', textAlign: 'center', paddingTop: '10px' }}>
                        {props.internalSignUpStatus !== '' ? null : props.registerStatus}
                        {props.showForgotPwdLinkWhileRegister
                            ? <span style={{ color: '#4785FF', cursor: 'pointer', textDecorationLine: 'underline' }} onClick={props.ForgotPassword}>reset your password ?</span>
                            : null
                        }
                        {props.internalSignUpStatus}
                    </div>
                </div>
            </div>
        </CCRCommonHeader >
    )
}

export default CCRSignUpForm;